import React, { useState } from 'react';
import styled from 'styled-components';
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const UnlockButton = styled.button`
  padding: 7px 21px;
  background: none;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  box-shadow: 0px 3px 14px rgb(55 42 121 / 20%);
  transition: all 0.2s;
  margin-right: 10px;
  font-size: 11px;
  &:hover {
    background: #f7f7f97a;
  }
  margin-right: 10px;
`;

const Secret = styled.p`
  user-select: none;
  text-shadow: 0 0 9px black;
  color: transparent;
`;

const Revealed = styled.p``;

const Parent = styled.div`
  display: flex;
  align-items: center;
`;

type Props = {
  secret: string | null | undefined;
  blurredText: string;
};

export function HiddenContent({ secret, blurredText }: Props) {
  const [revealed, setRevealed] = useState(false);

  return (
    <>
      <Parent>
        <UnlockButton onClick={() => setRevealed(!revealed)}>
          <FontAwesomeIcon
            icon={revealed ? faLockOpen : faLock}
            color={'#9092C1'}
          />
        </UnlockButton>
        {revealed ? (
          <Revealed>{secret}</Revealed>
        ) : (
          <Secret>{blurredText}</Secret>
        )}
      </Parent>
    </>
  );
}
